/*------------------------------------*\
    MODULES
\*------------------------------------*/
import getBreakpoint from "../helpers/get-breakpoint";
import { debounce } from "debounce";
import clickOutside from 'click-outside';

/*------------------------------------*\
    UPCOMING ENTRIES
\*------------------------------------*/
class UpcomingEntries {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        this.toggleEntry();
    }

    toggleEntry() {
        let self = this;

        self.trigger = self.elem.querySelector('[data-entry-trigger]');
        self.toggle = self.elem.querySelector('[data-entry-toggle]');

        self.trigger.addEventListener('click', evt => {
            self.toggle.classList.toggle('is-active');
        });
    }
}

export default UpcomingEntries;
